import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

/**
 * Toast notification container.
 * Uses sonner for lightweight toast notifications.
 *
 * Add to App root:
 * ```tsx
 * <Toaster />
 * ```
 *
 * Usage anywhere:
 * ```tsx
 * import { toast } from "sonner";
 *
 * toast.success("Saved successfully");
 * toast.error("Something went wrong");
 * toast.info("Processing...");
 * ```
 */
function Toaster({ ...props }: ToasterProps) {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
